import { Component } from '@angular/core';

@Component({
  selector: 'op-counter-sales-content',
  templateUrl: './counter-sales-content.component.html',
})
export class CounterSalesContentComponent {
}